/* eslint-disable no-unused-vars */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import createReducer from '../../../../../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  orders: [],
  loading: false,
  error: null,
};

const ordersReducer = createReducer(initialState, {
  [types.ORDERS_REQUEST](state, action) {
    return {
      ...state,
      data: action.data,
    };
  },
  [types.ORDERS_REQUEST_SUCCESS](state, action) {
    return {
      ...state,
      orders: action.response,
      error: null,
    };
  },
  [types.ORDERS_REQUEST_FAILED](state, action) {
    return {
      ...state,
      error: action.error
    };
  },
  [types.ORDERS_START_LOADING](state, action) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.ORDERS_STOP_LOADING](state, action) {
    return {
      ...state,
      loading: false,
    };
  },
  [types.ORDERS_RESET](state, action) {
    return {
      ...initialState,
    };
  },
});

export default ordersReducer;
